/**
 * Basis segmented control. There is no default basis on the API by design —
 * "how many people work here" has three defensible answers and the reader has
 * to pick one, so the control is the first thing on the page.
 */
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BASIS_OPTIONS, Def, type DefLookup, type WorkforceBasis } from './apiContract';

interface BasisToggleProps {
  value: WorkforceBasis;
  onChange: (basis: WorkforceBasis) => void;
  def: DefLookup;
  disabled?: boolean;
}

export const BasisToggle: React.FC<BasisToggleProps> = ({ value, onChange, def, disabled }) => (
  <div className="flex items-center gap-2">
    <span className="flex items-center text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-500">
      Basis
      <Def def={def} k="basis" />
    </span>
    <Tabs value={value} onValueChange={(v) => onChange(v as WorkforceBasis)}>
      <TabsList className="h-8">
        {BASIS_OPTIONS.map((b) => (
          <TabsTrigger
            key={b.id}
            value={b.id}
            disabled={disabled}
            className="px-3 text-[12px] data-[state=active]:bg-heritage-blue data-[state=active]:text-white"
          >
            {b.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  </div>
);
